import { render, staticRenderFns } from "./BucketResult.vue?vue&type=template&id=42768116&"
import script from "./BucketResult.vue?vue&type=script&lang=js&"
export * from "./BucketResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports